import { TimeScale } from '../types/Dashboard/types'

export const TIME_SCALE_OPTIONS = ['All', '1d', '1w', '1m', '3m', '6m', '1y', '3y'] as TimeScale[]
